import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { SocialHousingCalculatorComponent } from "./social-housing-calculator/social-housing-calculator.component";

const routes: Routes = [
  {
    path: "",
    component: SocialHousingCalculatorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
